import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "react-hot-toast";
import i18n from "~/app/i18n";
import { queryClient } from "~/app/query-client";
import { SessionProvider } from "~/shared/lib/auth/auth-provider";
import { UserProvider } from "~/app/UserContext";
import { NavigationBlockerProvider } from "~/shared/context/NavigationBlockerContext";
import { useLanguagePersistence } from "~/shared/hooks/useLanguagePersistence";
import { useDragDropPrevention } from "~/shared/hooks/useDragDropPrevention";
import { AppRoutes } from "~/app/router";
import YandexMetrica from "~/app/yandex-metrica";

function AppInner() {
    useLanguagePersistence();
    useDragDropPrevention();

    return (
        <>
            <div className="font-sans">
                <NavigationBlockerProvider>
                    <UserProvider>
                        <YandexMetrica />
                        <AppRoutes />
                        <Toaster
                            position="top-right"
                            toastOptions={{
                                duration: 4000,
                                // Toaster рендерится вне `.app-root`, поэтому
                                // CSS-vars (--card / --foreground / --border)
                                // не наследуются — фиксируем dark-палитру oklch
                                // вручную.
                                style: {
                                    background: "oklch(0.205 0 0)",
                                    color: "oklch(0.985 0 0)",
                                    border: "1px solid oklch(1 0 0 / 10%)",
                                },
                                success: {
                                    iconTheme: {
                                        primary: "oklch(0.696 0.17 162.48)",
                                        secondary: "oklch(0.205 0 0)",
                                    },
                                },
                                error: {
                                    duration: 6000,
                                    iconTheme: {
                                        primary: "oklch(0.704 0.191 22.216)",
                                        secondary: "oklch(0.985 0 0)",
                                    },
                                },
                            }}
                        />
                    </UserProvider>
                </NavigationBlockerProvider>
            </div>
        </>
    );
}

export function App() {
    return (
        <HelmetProvider>
            <I18nextProvider i18n={i18n}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <SessionProvider>
                            <AppInner />
                        </SessionProvider>
                    </BrowserRouter>
                </QueryClientProvider>
            </I18nextProvider>
        </HelmetProvider>
    );
}
